module.exports = __webpack_public_path__ + "static/media/edit.5dc0d756.svg";